const env = process.env.VUE_APP_ENV
let baseUrl
if (env === 'production') {
  baseUrl = 'https://xingfujia.coli688.com/super-gw/'
} else if (env === 'productionAly') {
  baseUrl = 'https://xfj.coli688.com/super-gw/'
} else {
  baseUrl = 'https://xfj.coli688.com/super-gw/'
}

export const headLineUrl = `${baseUrl}content-server/template/`
export const apiUrl = `${baseUrl}middle/super-gw/`
export const qqMapWxKey = 'R7RBZ-3M7YF-XGVJV-NGCZM-KK3AO-U3FLT'
export const trackerSocketUrl = 'wss://xfj.coli688.com'